<template>
  <div class="vx-row">
    <div class="vx-col w-full md:w-1/2">
      <div class="vx-row">
        <div class="vx-col w-full mb-5">
          <vx-card :title="$systemUnits.getTonnageLabel()" :subtitle="densityTitle" >
            <!-- CHART -->
            <template slot="no-body">
              <div class="mt-2 ml-5 mr-5" v-if="tonnageProgress">
                <div class="flex flex-col text-right mr-1">
                  <span>{{ tonnageProgress | toPercentage }}</span>
                </div>
                <vs-progress :percent="tonnageProgress"></vs-progress>
              </div>
            </template>

            <!-- DATA -->
            <div
              v-if="actualTonnage"
              class="flex justify-between text-center mt-2"
              slot="no-body-bottom">

                <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                    <p class="mt-2">{{ $t('GradeControl.Actual') }}</p>
                    <p class="mb-2 text-l font-semibold">{{ $systemUnits.convertTonnage(actualTonnage) | toFriendlyTonnage }}</p>
                </div>
                <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                    <p class="mt-2">{{ $t('GradeControl.Forecast.Name') }}</p>
                    <p class="mb-2 text-l font-semibold">{{ $systemUnits.convertTonnage(forecastTonnage) | toFriendlyTonnage }}</p>
                </div>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-5">
          <vx-card :title="$t('GradeControl.ProductionSummary.GoldProduction')" >
            <!-- CHART -->
            <template slot="no-body">
              <div class="mt-2 ml-5 mr-5" v-if="goldOzProgress">
                <div class="flex flex-col text-right mr-1">
                  <span>{{ goldOzProgress | toPercentage }}</span>
                </div>
                <vs-progress :percent="goldOzProgress"></vs-progress>
              </div>
            </template>

            <!-- DATA -->
            <div
              v-if="actualGoldOz"
              class="flex justify-between text-center mt-2"
              slot="no-body-bottom">

                <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                    <p class="mt-2">{{ $t('GradeControl.Actual') }}</p>
                    <p class="mb-2 text-l font-semibold">{{ actualGoldOz | toFriendlyTonnage }}</p>
                </div>
                <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                    <p class="mt-2">{{ $t('GradeControl.Forecast.Name') }}</p>
                    <p class="mb-2 text-l font-semibold">{{ forecastGoldOz | toFriendlyTonnage }}</p>
                </div>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-5">
          <vx-card :title="$t('GradeControl.ProductionSummary.Sample')" >
              <!-- CHART -->
              <template slot="no-body">
                <div class="mt-2 ml-5 mr-5" v-if="sampleProgress">
                  <div class="flex flex-col text-right mr-1">
                    <span>{{ sampleProgress | toPercentage }}</span>
                  </div>
                  <vs-progress :percent="sampleProgress"></vs-progress>
                </div>
              </template>
              <!-- DATA -->
              <div
                v-if="actualGoldOz"
                class="flex justify-between text-center mt-4"
                slot="no-body-bottom">

                  <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                      <p class="mt-4">{{ $t('GradeControl.ProductionSummary.ReceivedSamples') }}</p>
                      <p class="mb-4 text-l font-semibold">{{ receivedSamples }}</p>
                  </div>
                  <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                      <p class="mt-4">{{ $t('GradeControl.ProductionSummary.TotalSamples') }}</p>
                      <p class="mb-4 text-l font-semibold">{{ totalSamples }}</p>
                  </div>
              </div>
          </vx-card>
        </div>
      </div>
    </div>
    <div class="vx-col w-full md:w-1/2">
      <vx-card :title="$t('GradeControl.Grade')" class="mb-base">
        <div v-for="(statistics, index) in gradeStatistics" :key="statistics.element" :class="{'mt-4': index}">
          <div class="flex justify-between">
            <div class="flex flex-col">
                <span class="mb-1">{{$t("Element." + statistics.element)}}</span>
                <h4>{{ $systemUnits.convertGradeRounded(statistics.actualGrade, statistics.element) | toFriendlyGrade }} {{ getSuffix(statistics.element) }}</h4>
            </div>
            <div class="flex flex-col text-right">
              <span class="flex -mr-1">
                  <span class="mr-1">{{ $systemUnits.convertGradeRounded(statistics.forecastGrade, statistics.element) }}</span>
                  <feather-icon :icon=" statistics.comparedResult < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[statistics.comparedResult < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
              </span>
            </div>
          </div>
          <vs-progress :percent="statistics.ratio"></vs-progress>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>

import ElementEnum  from "@/app/shared/ElementEnum.js";
import GradeCalculationTypeEnum  from "../../GradeCalculationTypeEnum.js";

export default {
  components: {
  },
  data() {
    return {
      forecastDensity: null,
      forecastTonnage: null,
      actualTonnage:null,
      tonnageProgress:null,
      gradeStatistics: null,
      goldOzProgress: null,
      sampleProgress: null,
      forecastGoldOz: null,
      actualGoldOz:null,
      chartOptions: {
        plotOptions: {
          radialBar: {
            size: 150,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '77%'
            },
            track: {
              background: '#bfc5cc',
              strokeWidth: '50%'
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: 12,
                color: '#99a2ac',
                fontSize: '2rem'
              }
            }
          }
        },
        colors: ['#00db89'],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#00b5b5'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: 'round'
        },
        chart: {
          sparkline: {
            enabled: true
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1
          }
        }
      }
    };
  },
  computed: {
    densityTitle() {
      return this.$options.filters.toFriendlyDensity(this.$systemUnits.convertDensity(this.forecastDensity));
    }
  },
  methods: {
    getSuffix(element) {
      if (element === ElementEnum.Gold || element === ElementEnum.Silver)
        return this.$t(this.$store.getters.isProjectImperial ? 'GradeControl.CappingUnitImperial' : 'GradeControl.CappingUnit').replace('(', '').replace(')', '');
      else
        return "%";
    },
    defineForecastAndActual(locationForecastId, gradeCalculation) {
      if (locationForecastId) {
        return this.$store.dispatch("gradeControl/fetchForecastStats", {
          locationForecastId,
          includeHauling: false }).then(() => {
          this.affectAttributes(this.$store.state.gradeControl.forecastStats, gradeCalculation)
        });
      }
    },
    getGradeResults(gradeCalculation) {
      switch (gradeCalculation) {
      case GradeCalculationTypeEnum.SampleOnly:
        return this.$store.state.gradeControl.forecastStats.sampleOnlyResults;
      case GradeCalculationTypeEnum.SampleOrForecast:
        return this.$store.state.gradeControl.forecastStats.sampleOrForecastResults;
      case GradeCalculationTypeEnum.SampleOnlyCapped:
        return this.$store.state.gradeControl.forecastStats.sampleOnlyCappedResults;
      case GradeCalculationTypeEnum.SampleOrForecastCapped:
        return this.$store.state.gradeControl.forecastStats.sampleOrForecastCappedResults;
      }
    },
    affectAttributes(stats, gradeCalculation) {

      this.forecastTonnage = stats.forecastTonnage;
      this.actualTonnage = stats.actualTonnage;
      this.tonnageProgress = stats.forecastTonnage === 0 ? 100 : this.actualTonnage / this.forecastTonnage * 100;

      this.forecastGoldOz = stats.forecastGoldOz;
      this.actualGoldOz = stats.actualGoldOz;
      this.goldOzProgress = stats.forecastGoldOz === 0 ? 100 : this.actualGoldOz / this.forecastGoldOz * 100;

      this.receivedSamples = stats.receivedSamples;
      this.totalSamples = stats.totalSamples;
      this.sampleProgress = stats.totalSamples === 0 ? 100 : this.receivedSamples / this.totalSamples * 100;

      this.forecastDensity = stats.forecastDensity;

      const grades = [];
      const gradesResults = this.getGradeResults(gradeCalculation);

      const elementArray = [ElementEnum.Gold, ElementEnum.Silver, ElementEnum.Copper, ElementEnum.Zinc, ElementEnum.Lead, ElementEnum.Carbon, ElementEnum.Sulfur];

      elementArray.forEach(element => {
        const forecastResult = this.$store.state.gradeControl.forecastStats.forecastResults.find(r => r.element === element);
        let forecastGrade = null;
        if (typeof forecastResult !== 'undefined' && forecastResult.grade !== null) {
          forecastGrade = forecastResult.grade;
        }

        const actualResult = gradesResults.find(r => r.element === element);
        let actualGrade = null;
        if (typeof actualResult !== 'undefined' && actualResult.grade !== null) {
          actualGrade = actualResult.grade;
        }

        if (forecastGrade !== null || actualGrade !== null)
        {
          grades.push({
            element,
            forecastGrade,
            actualGrade,
            'comparedResult' : actualGrade - forecastGrade,
            'ratio' : actualGrade / forecastGrade * 100});
        }

      });

      this.gradeStatistics = grades;
    }
  }
};
</script>
